<template>
	<div click.stop>
		<div class="modal is-active">
			<div class="modal-background" @click="cancel"></div>
			<div class="modal-card narrow">
				<header class="modal-card-head">
					<p class="modal-card-title">
						{{ editQuestionGroup.id ? $t('addgroup.edit_title') : $t('addgroup.new_title') }} {{ $t('addgroup.title_suffix') }}
					</p>
					<button class="delete" aria-label="close" @click="cancel"></button>
				</header>
				<section class="modal-card-body">
					<div class="field">
						<label class="label">{{ $t('addgroup.name_label') }}</label>
						<div class="control">
							<textarea
								v-model="questionGroup.name"
								rows="2"
								class="textarea"
								:placeholder="$t('addgroup.name_placeholder')"
							/>
						</div>
					</div>
					<div class="field" v-if="$isAllowedTo('global_set_object_as_global')">
						<label class="label">{{ $t('addgroup.global_label') }}</label>
						<SwitchButton v-model="globalVisibility" />
					</div>
				</section>
				<footer class="modal-card-foot">
					<button
						class="button is-dark"
						:class="isLoading ? 'is-loading' : ''"
						:disabled="disableSave"
						@click="save"
					>
						<span class="icon is-info"><i class="fas fa-save"/></span
						><span>{{ $t('addgroup.save_button') }}</span>
					</button>
				</footer>
			</div>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';

import SwitchButton from '@/components/switchButton.vue';

export default {
	components: {
		SwitchButton
	},
	props: {
		editQuestionGroup: Object
	},
	data() {
		return {
			questionGroup: {
				name: ''
			},
			isLoading: false,
			companyOptions: [],
			globalVisibility: false
		};
	},
	computed: {
		...mapGetters('user', ['getActiveCompany', 'getActiveCustomer']),
		disableSave() {
			return this.questionGroup.name == '';
		}
	},
	methods: {
		save() {
			if (this.globalVisibility) {
				this.questionGroup.companyId = null;
				this.questionGroup.customerId = null;
			} else {
				if (this.questionGroup.companyId == null)
					this.questionGroup.companyId = this.getActiveCompany.id;

				this.questionGroup.customerId = this.getActiveCustomer.id;
			}

			if (!this.isLoading) {
				this.$emit('save', this.questionGroup);
			}

			this.isLoading = true;
		},
		cancel() {
			this.$emit('cancel');
		}
	},
	created() {
		if (this.editQuestionGroup) {
			Object.assign(this.questionGroup, this.editQuestionGroup);
		}

		this.globalVisibility = this.questionGroup.companyId === null;
	}
};
</script>
